// export const baseURL = 'http://ggdiet.ngrok.maxne.club'
export const baseURL = 'https://ncapi.micropower.net.cn'
// export const baseURL = 'http://diet.ngrok.maxne.club'
// export const baseURL = 'http://188049k8k4.iok.la'
// export const baseURL = 'http://15620931065.imwork.net/'
// export const baseURL = 'http://maxne.iok.la'

// 部门下拉假数据
export const DEPARTMENT_LIST = [
  '安全科',
  '办公室',
  '财务科',
  '党办',
  '工会',
  '公寓',
  '纪委',
  '技术和信息化科',
  '经营开发部',
  '劳人科',
  '南仓站',
  '设备维修车间',
  '调度',
  '团委',
  '信息化车间',
  '运三车间',
  '运输可科',
  '职教科室',
  '综治内保科',
  '安保队',
  '安全生产调度指挥中心',
  '货检',
  '天津货运中心',
  '运一',
  '运二',
  '运三',
  '四车间'
]

// 报表起止时间
export const REPORT_START_TIME = {
  date: 26,
  hour: 15
}

// 三餐结束时间
export const DINNER_TIME = {
  breakfast: 8,
  lunch: 13,
  dinner: 19
}
